import React, { useState } from "react";

import * as styles from "./permissionelement.module.scss";

const DragablePermissionElement = ({ onDrop, type, item, index }: any) => {
  const scssClass = styles as any;
  const [showDrop, setShowDrop] = useState(false);
  return (
    <section
      onDragEnter={() => setShowDrop(true)}
      onDragLeave={() => setShowDrop(false)}
      className={showDrop ? scssClass["drop-area"] : scssClass["hide-drop"]}
      onDrop={() => {
        if (item) {
          const [draggedType, index] = item.split("-");
          if (draggedType === type) {
            onDrop(+index); // Ensure position is correctly passed
            setShowDrop(false); // Reset the drop state
          } else {
            setShowDrop(false);
          }
        }
      }}
      onDragOver={(e) => e?.preventDefault()}
      data-testid={`drag-${type}-${index}`}
    >
      Drop here
    </section>
  );
};

export default DragablePermissionElement;
